import { render, staticRenderFns } from "./HistoricalExportList.vue?vue&type=template&id=620f6dcb&scoped=true&"
import script from "./HistoricalExportList.vue?vue&type=script&lang=js&"
export * from "./HistoricalExportList.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalExportList.vue?vue&type=style&index=0&id=620f6dcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f6dcb",
  null
  
)

export default component.exports